import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './relationshipTree.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { RelationshipTree } from "model/dealer/relationshipTree.model";

export interface RelationshipTreeDetailsProps extends DetailsStateAndDispatchProps<RelationshipTree>,
  RouteComponentProps, StateProps, DispatchProps {
}
const RelationshipTreeDetails: FC<RelationshipTreeDetailsProps> = (props) => {
  return (
    <DetailsPage<RelationshipTree>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<RelationshipTree>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ relationshipTree }: RootState) => ({
  entity: relationshipTree.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RelationshipTreeDetails);
